import React from "react";
import styles from "./eligibility-modal.module.scss";

export type RepaymentRow = {
  label: string;
  value: string;
};

const EligibilityModal = ({
  rows,
  onContinue,
  onClose,
  title,
  subtitle,
  continueLabel,
  isSuccess,
}: {
  rows: RepaymentRow[];
  onContinue: () => void;
  onClose: () => void;
  isSuccess: boolean;
  title?: string;
  subtitle?: string;
  continueLabel?: string;
}) => {
  const defaultTitle = isSuccess ? "Congratulations!" : "Application Failed";
  const defaultSubtitle = isSuccess
    ? "You are eligible for this mortgage application"
    : "You are not eligible for this mortgage application";

  return (
    <div className={styles["save-cont"]}>
      <div className={styles["inner-cont"]}>

        <div className={styles["close-cont"]} role="button" onClick={onClose}>
          ✕
        </div>

        <div className={`${styles["icon-circle"]} ${isSuccess ? styles["icon-circle--success"] : styles["icon-circle--error"]}`}>
          {isSuccess ? (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5"
              strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          ) : (
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2.5"
              strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          )}
        </div>

        <span className={styles["save-quote-header"]}>
          {title ?? defaultTitle}
          <br />
          {subtitle ?? defaultSubtitle}
        </span>

        {isSuccess && (
          <div className={styles["info-box"]}>
            {rows.map((row, i) => (
              <div
                key={i}
                className={`${styles["info-row"]} ${i > 0 ? styles["info-row--bordered"] : ""}`}
              >
                <span className={styles["payment-text-w"]}>{row.label}</span>
                <span className={styles["payment-text"]}>{row.value}</span>
              </div>
            ))}
          </div>
        )}

        <div
          className={`${styles["cta-button"]} ${isSuccess ? styles["cta-button--success"] : styles["cta-button--error"]}`}
          role="button"
          onClick={isSuccess ? onContinue : onClose}
        >
          <span>{continueLabel ?? (isSuccess ? "Continue Application" : "Go Back")}</span>
        </div>

      </div>
    </div>
  );
};

export default EligibilityModal;